import { __decorate } from "tslib";
import { css, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { AuthService } from '../common/authentication/authService.js';
import { RxElement } from '../common/reactiveX/rxElement.js';
import { subscribe } from '../common/reactiveX/rxElementDecorators.js';
import { AuthGuard } from '../common/authentication/authGuard.js';
import './login.js';
import './notFound.js';
import './coaching/advisee/adviseeSummary.js';
import './fulfillment/summary.js';
import '../common/mainLayout.js';
let BlueApp = class BlueApp extends RxElement {
    constructor() {
        super(...arguments);
        this.route = window.location;
        this.routerInitialized = false;
        this.authGuard = new AuthGuard();
        this.splashRemoved = false;
    }
    connectedCallback() {
        // eslint-disable-next-line wc/guard-super-call
        super.connectedCallback();
        AuthService.start();
        window.addEventListener('popstate', () => {
            this.route = window.location;
        });
    }
    disconnectedCallback() {
        AuthService.stop();
        // eslint-disable-next-line wc/guard-super-call
        super.disconnectedCallback();
    }
    updated(changedProperties) {
        if (changedProperties.has('blueUser') && this.blueUser.status === 'AUTHENTICATED') {
            this.initRoutes();
        }
    }
    async initRoutes() {
        await this.authGuard.appRoutes();
        this.routerInitialized = true;
    }
    render() {
        var _a;
        if (!this.splashRemoved) {
            (_a = document.getElementById('splash')) === null || _a === void 0 ? void 0 : _a.remove();
            this.splashRemoved = true;
        }
        if (this.blueUser.status !== 'AUTHENTICATED') {
            return html `<blue-login></blue-login>`;
        }
        if (this.route.pathname.toLocaleLowerCase().startsWith('/coaching/advisee')) {
            const searchParams = new URLSearchParams(this.route.search);
            const email = searchParams.get('email');
            const hub = searchParams.get('hub') || searchParams.get('slug');
            if (!email || !hub) {
                return html `<not-found></not-found>`;
            }
            return html `<advisee-summary email=${email} hubSlug=${hub}></advisee-summary>`;
        }
        return html ``;
    }
};
BlueApp.styles = css `
		mwc-button {
			--mdc-theme-primary: #12447c;
			--mdc-theme-on-primary: white;
		}
	`;
__decorate([
    subscribe(),
    state()
], BlueApp.prototype, "blueUser", void 0);
__decorate([
    state()
], BlueApp.prototype, "route", void 0);
__decorate([
    state()
], BlueApp.prototype, "routerInitialized", void 0);
__decorate([
    state()
], BlueApp.prototype, "authGuard", void 0);
BlueApp = __decorate([
    customElement('blue-app')
], BlueApp);
export { BlueApp };
//# sourceMappingURL=blueApp.js.map